import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/ACCopenanalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/ACCopenanalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/ACCopenanalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGroupswitchtypelimit = (params, urlParams) => {
  return axios.request({
    url: '/da/ACCopenanalysisregulation/ACCopenanalysisregulation/updatevehicleInfoGroupswitchtypelimit/' + params.vehicleInfoGroupids + '/' + params.switchtype + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const dateswitchtypelimit = (params, urlParams) => {
  return axios.request({
    url: '/da/ACCopenanalysisregulation/ACCopenanalysisregulation/' + params.terminalNum + '/' + params.switchtype + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

